import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef();

  const languages = [
    { code: 'en', name: 'English', flag: '🇺🇸' },
    { code: 'fr', name: 'Français', flag: '🇫🇷' },
    { code: 'de', name: 'Deutsch', flag: '🇩🇪' }
  ];

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setIsOpen(false);
  };

  // Close on outside click
  useEffect(() => {
    const onClick = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  return (
    <div ref={containerRef} className="language-selector-container">
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="language-selector-toggle"
        aria-haspopup="listbox"
        aria-expanded={isOpen}
      >
        <span className="flag">{currentLanguage.flag}</span>
        {currentLanguage.name}
        <span className="dropdown-arrow">{isOpen ? '▲' : '▼'}</span>
      </button>

      {isOpen && (
        <div className="language-selector-panel">
          <ul className="language-selector-list" role="listbox">
            {languages.map((lang) => (
              <li
                key={lang.code}
                role="option"
                aria-selected={i18n.language === lang.code}
                onClick={() => changeLanguage(lang.code)}
                className={`language-selector-item ${i18n.language === lang.code ? 'selected' : ''}`}
              >
                <span className="flag">{lang.flag}</span>
                {lang.name}
                {i18n.language === lang.code && <span className="checkmark">✓</span>}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;